<template>
  <b-container>
    <b-row class="mb-1">
      <h2>{{ $t("system.systemIntegrationCompany.sidebar") }}</h2>
      <success-fade-alert ref="alert" msg="Formulário exluido com sucesso" />
      <fade-alert-danger ref="danger" msg="Formulário não exluido" />
    </b-row>

    <b-row>
      <b-table
        ref="MyForm"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
      >
        <template v-slot:cell(actions)="data">
          <b-button
            v-if="!data.item.active"
            size="sm"
            @click="integrationAdd(data.item)"
            >{{ $t("geral.add") }}</b-button
          >
          <b-button
            v-if="data.item.active"
            size="sm"
            @click="integrationRemove(data.item)"
            variant="danger"
            >{{ $t("geral.delete") }}</b-button
          >
          <router-link
            :to="
              '../../systemIntegrationCompany/List/' +
              data.item.companyId +
              '/' +
              data.item.systemIntegrationId
            "
          >
            <b-button class="ml-2" size="sm" variant="green">{{
              $t("geral.connections")
            }}</b-button>
          </router-link>
        </template>
        <!-- <template v-slot:cell(id)="data">
          <router-link :to="'./edit/' + data.value">
            <b-button size="sm">{{ $t("geral.editar") }}</b-button>
          </router-link>
        </template> -->
      </b-table>
    </b-row>
    <b-row>
      <b-col>
        <b-pagination
          v-model="tableCurrentPage"
          :total-rows="tableRowCount"
          :per-page="tablePerPage"
          first-number
          last-number
          aria-controls="table-tabela-proceda"
        />
      </b-col>
      <b-col>
        <label for="perPageSelect"
          >Exibindo {{ paginationFrom }} até {{ paginationTo }} de um total de
          {{ tableRowCount }}</label
        >
      </b-col>
      <b-col>
        <b-row>
          <b-col>
            <b-form-select
              v-model="tablePerPage"
              id="perPageSelect"
              size="sm"
              :options="tablePageOptions"
            />
          </b-col>
          <b-col>
            <label for="perPageSelect">Registros exibidos por página</label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";

export default {
  components: {
    FadeAlertDanger,
    SuccessFadeAlert,
  },
  props: {
    empresaId: String,
  },
  data: function () {
    return {
      isBusy: false,
      fields: [
        {
          key: "actions",
          label: "",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "active",
          label: this.$t("system.systemIntegrationCompany.integrated"),
          tdClass: "table-col-dinamic-width",
          formatter: (value, key, item) => {
            if (item.active) {
              return "Sim";
            }
            return "Não";
          },
        },
        {
          key: "systemIntegrationDisplayName",
          label: this.$t("system.systemIntegrationCompany.systemName"),
          sortable: true,
        },
      ],
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
    };
  },
  computed: {
    paginationFrom() {
      return this.tablePerPage * (this.tableCurrentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.tablePerPage;
      if (to > this.tableRowCount) return this.tableRowCount;
      return to;
    },
  },
  methods: {
    myProvider(ctx, callback) {
      this.isBusy = true;
      this.$apiChecklist
        .get("/systemIntegrationCompany/alltoggle/" + this.empresaId.toString())
        .then((response) => {
          const items = response.data;
          callback(items);
        })
        .catch((error) => {
          callback([]);
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }
        });
      return null;
    },
    integrationAdd(integration) {
      this.$apiChecklist
        .get(
          "/systemIntegrationCompany/add/" +
            integration.companyId.toString() +
            "/" +
            integration.systemIntegrationId.toString()
        )
        .then((response) => {
          const data = response.data;
          integration.active = data.active;
          integration.systemIntegrationCompanyId =
            data.systemIntegrationCompanyId;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }
        });
    },
    integrationRemove(integration) {
      this.$apiChecklist
        .get(
          "/systemIntegrationCompany/delete/" +
            integration.companyId.toString() +
            "/" +
            integration.systemIntegrationId.toString()
        )
        .then((response) => {
          const data = response.data;
          integration.active = data.active;
          integration.systemIntegrationCompanyId = 0;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }
        });
    },
    deleteForm(id) {
      this.$apiChecklist
        .get("/form/delete/" + id.toString())
        .then((response) => {
          this.$refs.MyForm.refresh();
          this.$refs.alert.show();
        })
        .catch((error) => {
          console.log(error.response);
          this.$refs.danger.msg =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
  },
};
</script>

